import React, { Component } from 'react';
import {
    toggle_on_icon,
    toggle_off_icon,
    isStaticMode,
} from '../../utils/general/general';
import { enterKeyPressed } from '../../utils/general/enterKey';
import commonStore from '../../store/commonStore';
import * as commonStateAction from '../../actions/commonStateAction';
import { IReducerState } from '../../states/renditionStates';
import { connect } from 'react-redux';
import $ from 'jquery';

interface IHtmlPdfToggleBarProps {
    showPDFDigidocViewer: boolean;
    htmlPDFtoggleStatus: boolean;
}

interface IHtmlPdfToggleBarStatus {
    toggleStatus: boolean;
}

export class HtmlPdfToggleBar extends Component<IHtmlPdfToggleBarProps, IHtmlPdfToggleBarStatus> {

    constructor(props: any) {
        super(props);
        this.state = {
            toggleStatus: true,
        };
    }

    public componentDidUpdate() {
        if (!this.props.htmlPDFtoggleStatus && !$('#slider').hasClass('collapsed')) {
            $('#slider').click();
        }
    }

    public handleToggleClick() {
        commonStore.dispatch(commonStateAction.htmlPDFtoggleStatus(!this.props.htmlPDFtoggleStatus));
    }

    public render() {
        const showHTMLPDFTogglePane = this.props.showPDFDigidocViewer &&
            window.HTML_RENDITION.initialData.productType !== 'blog' &&
            window.HTML_RENDITION.initialData.mode !== 'preview_mode' && !isStaticMode();

        return (
            <div className={showHTMLPDFTogglePane ? 'toggleBar' : 'd-none'}>
                <span className={'htmlButton ' + (this.props.htmlPDFtoggleStatus ? 'bold' : '')}>HTML</span>
                <img
                    role="button"
                    tabIndex={0}
                    src={this.props.htmlPDFtoggleStatus ? toggle_on_icon : toggle_off_icon}
                    className='HTML_PDF_switch'
                    onClick={() => this.handleToggleClick()}
                    onKeyPress={(e) => enterKeyPressed(e, this.handleToggleClick.bind(this))}
                    aria-label="HTML/PDF toggle"
                />
                <span className={'pdfButton ' + (!this.props.htmlPDFtoggleStatus ? 'bold' : '')}>PDF</span>
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        htmlPDFtoggleStatus: state.commonStateReducer.htmlPDFtoggleStatus,
    };
};

export default connect(mapStateToProps)(HtmlPdfToggleBar);
